import $  from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Plyr from 'plyr';

function videoBanner(){

    $('.hero-bg').each(function(){
        let player = false;
        let block = $(this);
        let videoBlock = $(this).find('.video');
        var videoPoster = videoBlock.data("poster");
        if(videoBlock.hasClass('video--oembed')){
            player = new Plyr(videoBlock.get(0), {
                controls: ['play-large'],
                autoplay: true,
                vimeo: {autoplay: true , loop: true, trasparent: true, background: true},
                youtube: {autoplay: true},
                muted: true,
                volume: 0,
                fullscreen: { enabled: false }
            });
            player.on('ready', event => {
                let video = block.find('.plyr__video-embed__container');
                let bannerInner = block;
                function videoSize() {
                    var $windowHeight = block.height();
                    var $videoHeight = video.outerHeight();
                    var $scale = $windowHeight / $videoHeight;
                    console.log($videoHeight , $windowHeight);
                    if ($videoHeight <= $windowHeight) {
                        video.attr('style',
                            "-webkit-transform:scale("+$scale+") translateY(0%)!important; transform:scale("+$scale+") translateY(0%)!important"
                        );
                    };
                }
                videoSize();
                $(window).on('load resize',function(){
                    videoSize();
                });
            });
        } else{
            player = false;
            /*
            player = new Plyr(videoBlock.get(0), {
                controls: ['play-large'],
                autoplay: true,
                vimeo: {autoplay: true},
                youtube: {autoplay: true},
                muted: true,
                volume: 0,
                fullscreen: { enabled: false }
            });
            */
        }
        if (videoPoster && player) player.poster = videoPoster;
        $(window).on('loadCompleted',function(){
            if(player){
                player.muted = true;
                player.volume = 0;
                player.play();

                gsap.from(block ,{
                    scrollTrigger: {
                        trigger: block,
                        pin:false,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: 1,
                        markers: false,
                        onToggle: function(self){
                            if(self.isActive){
                                player.play();
                            } else{
                                player.pause();
                            }
                        },
                    },        
                });
               
            }
        })
    })

}

export { videoBanner };